export default {
    name: "SchemaMarkupButton",

    props: {
        label: { type: String, default: "" }
    }
}
